var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAFlagUk = function SvgAFlagUk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": true
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9904 0H0V13.9981H17.9904V0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0958 8.3944V13.9981H9.8952V8.3944H17.9904V5.59627H9.8952V0H8.0958V5.59627H0V8.3944H8.0958Z",
    fill: "#CF142B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4946 4.53133V0H16.3194L10.4946 4.53133Z",
    fill: "#00247D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4946 9.46681V13.9981H16.3194L10.4946 9.46681Z",
    fill: "#00247D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.4957 9.46681V13.9981H1.6709L7.4957 9.46681Z",
    fill: "#00247D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.4957 4.53133V0H1.6709L7.4957 4.53133Z",
    fill: "#00247D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.30106V4.66572H4.3254L0 1.30106Z",
    fill: "#00247D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9908 1.30106V4.66572H13.666L17.9908 1.30106Z",
    fill: "#00247D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9908 12.6971V9.3324H13.666L17.9908 12.6971Z",
    fill: "#00247D"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.6971V9.3324H4.3254L0 12.6971Z",
    fill: "#00247D"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9903 0H16.9913L11.0039 4.66573H12.0029L17.9999 0",
    fill: "#CF142B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9864 9.3324H5.9874L0 13.9981H0.999L6.996 9.3324",
    fill: "#CF142B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M4.9962 4.66947H5.9952L0 0V0.782133L4.9962 4.66947Z",
    fill: "#CF142B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9912 9.33054H11.9922L17.9874 14V13.2179L12.9912 9.33054Z",
    fill: "#CF142B"
  })));
};
export { SvgAFlagUk as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxOCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE3Ljk5MDQgMEgwVjEzLjk5ODFIMTcuOTkwNFYwWiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTguMDk1OCA4LjM5NDRWMTMuOTk4MUg5Ljg5NTJWOC4zOTQ0SDE3Ljk5MDRWNS41OTYyN0g5Ljg5NTJWMEg4LjA5NThWNS41OTYyN0gwVjguMzk0NEg4LjA5NThaIiBmaWxsPSIjQ0YxNDJCIi8+CjxwYXRoIGQ9Ik0xMC40OTQ2IDQuNTMxMzNWMEgxNi4zMTk0TDEwLjQ5NDYgNC41MzEzM1oiIGZpbGw9IiMwMDI0N0QiLz4KPHBhdGggZD0iTTEwLjQ5NDYgOS40NjY4MVYxMy45OTgxSDE2LjMxOTRMMTAuNDk0NiA5LjQ2NjgxWiIgZmlsbD0iIzAwMjQ3RCIvPgo8cGF0aCBkPSJNNy40OTU3IDkuNDY2ODFWMTMuOTk4MUgxLjY3MDlMNy40OTU3IDkuNDY2ODFaIiBmaWxsPSIjMDAyNDdEIi8+CjxwYXRoIGQ9Ik03LjQ5NTcgNC41MzEzM1YwSDEuNjcwOUw3LjQ5NTcgNC41MzEzM1oiIGZpbGw9IiMwMDI0N0QiLz4KPHBhdGggZD0iTTAgMS4zMDEwNlY0LjY2NTcySDQuMzI1NEwwIDEuMzAxMDZaIiBmaWxsPSIjMDAyNDdEIi8+CjxwYXRoIGQ9Ik0xNy45OTA4IDEuMzAxMDZWNC42NjU3MkgxMy42NjZMMTcuOTkwOCAxLjMwMTA2WiIgZmlsbD0iIzAwMjQ3RCIvPgo8cGF0aCBkPSJNMTcuOTkwOCAxMi42OTcxVjkuMzMyNEgxMy42NjZMMTcuOTkwOCAxMi42OTcxWiIgZmlsbD0iIzAwMjQ3RCIvPgo8cGF0aCBkPSJNMCAxMi42OTcxVjkuMzMyNEg0LjMyNTRMMCAxMi42OTcxWiIgZmlsbD0iIzAwMjQ3RCIvPgo8cGF0aCBkPSJNMTcuOTkwMyAwSDE2Ljk5MTNMMTEuMDAzOSA0LjY2NTczSDEyLjAwMjlMMTcuOTk5OSAwIiBmaWxsPSIjQ0YxNDJCIi8+CjxwYXRoIGQ9Ik02Ljk4NjQgOS4zMzI0SDUuOTg3NEwwIDEzLjk5ODFIMC45OTlMNi45OTYgOS4zMzI0IiBmaWxsPSIjQ0YxNDJCIi8+CjxwYXRoIGQ9Ik00Ljk5NjIgNC42Njk0N0g1Ljk5NTJMMCAwVjAuNzgyMTMzTDQuOTk2MiA0LjY2OTQ3WiIgZmlsbD0iI0NGMTQyQiIvPgo8cGF0aCBkPSJNMTIuOTkxMiA5LjMzMDU0SDExLjk5MjJMMTcuOTg3NCAxNFYxMy4yMTc5TDEyLjk5MTIgOS4zMzA1NFoiIGZpbGw9IiNDRjE0MkIiLz4KPC9zdmc+Cg==";